(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Selector "Mostrar por página" (24/50/100/Todas) + paginación — cliente, sin recargar
  const initPerPage = () => {
    const box = document.querySelector('.results-per-page');
    if (!box || box.dataset.bound === '1') return;
    box.dataset.bound = '1';
    const total = parseInt(box.dataset.total || '0', 10);
    const counter = document.querySelector('.results-counter__text');
    if (!counter || !total) return;

    const grid = box.closest('results-list')?.querySelector('[ref="grid"]');
    const cards = grid ? Array.from(grid.querySelectorAll('[ref="cards[]"]')) : [];
    const nav = document.querySelector('.results-pagination');
    const pagesEl = nav ? nav.querySelector('.results-pagination__pages') : null;

    const saved = parseInt(localStorage.getItem('auren_per_page') || '24', 10);
    let perPage = saved === 24 || saved === 50 || saved === 100 ? saved : 24;
    let page = 1;

    const totalPages = (n) => Math.max(1, Math.ceil(total / n));

    const renderPagination = (n) => {
      if (!nav || !pagesEl) return;
      const tp = totalPages(n);
      if (tp <= 1) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      pagesEl.textContent = '';
      for (let i = 1; i <= tp; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'results-pagination__num' + (i === page ? ' is-active' : '');
        btn.textContent = String(i);
        btn.setAttribute('aria-label', 'Página ' + i);
        btn.addEventListener('click', () => {
          page = i;
          apply(n);
        });
        pagesEl.appendChild(btn);
      }
      const prev = nav.querySelector('[data-page="prev"]');
      const next = nav.querySelector('[data-page="next"]');
      if (prev) prev.disabled = page <= 1;
      if (next) next.disabled = page >= tp;
    };

    const apply = (n) => {
      const start = (page - 1) * n;
      cards.forEach((card, i) => {
        card.style.display = i >= start && i < start + n ? '' : 'none';
      });
      const from = total > 0 ? start + 1 : 0;
      const to = Math.min(start + n, total);
      counter.textContent = 'Mostrando ' + from + '-' + to + ' de ' + total;
      box.querySelectorAll('[data-per-page]').forEach((btn) => {
        const val = btn.dataset.perPage;
        const isActive = val === 'all' ? n >= total : parseInt(val, 10) === n;
        btn.classList.toggle('is-active', isActive);
      });
      renderPagination(n);
    };

    box.querySelectorAll('[data-per-page]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const val = btn.dataset.perPage;
        perPage = val === 'all' ? total : parseInt(val, 10);
        page = 1;
        localStorage.setItem('auren_per_page', String(perPage));
        apply(perPage);
      });
    });

    if (nav) {
      const prev = nav.querySelector('[data-page="prev"]');
      const next = nav.querySelector('[data-page="next"]');
      prev?.addEventListener('click', () => {
        if (page > 1) {
          page -= 1;
          apply(perPage);
        }
      });
      next?.addEventListener('click', () => {
        if (page < totalPages(perPage)) {
          page += 1;
          apply(perPage);
        }
      });
    }

    apply(perPage);
  };

  document.addEventListener('DOMContentLoaded', initPerPage);
  // El tema re-renderiza la sección al filtrar/ordenar (AJAX): re-aplicar
  document.addEventListener('collectionUpdate', () => setTimeout(initPerPage, 50));
  document.addEventListener('searchUpdate', () => setTimeout(initPerPage, 50));

  } catch(e) { console.error(e); }
})();
})();
